import React from "react";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import "../styles/UsersegmentPie.css";

// 5 colors for 5 sections
const COLORS = [
  "#22c55e", // Breakfast
  "#3b82f6", // Lunch
  "#f97316", // Snacks
  "#ef4444", // Dinner
  "#a855f7", // Late Night
];

const MealPieChart = ({ selectedRestData, pieTitle }) => {
  // get latest row safely
  const newDataValue =
    selectedRestData.length > 0
      ? selectedRestData[selectedRestData.length - 1]
      : {};

  // data for 5 sections
  const data = [
    { name: "Bf Order", value: newDataValue?.bf_orders || 0 },
    { name: "Ln Order", value: newDataValue?.ln_orders || 0 },
    { name: "Sp Orders", value: newDataValue?.sp_orders || 0 },
    { name: "Dp Orders", value: newDataValue?.dp_orders || 0 },
    { name: "Ltn Orders", value: newDataValue?.ltn_orders || 0 },
  ];

  // total calculation
  const total = data.reduce((acc, curr) => acc + curr.value, 0);

  return (
    <div className="analytics-card">
      <h3 className="chart-title" style={{ marginBottom: "10px" }}>
        {pieTitle}
      </h3>

      <ResponsiveContainer width="100%" height={310}>
        <PieChart>
          <Pie
            data={data}
            innerRadius={70}
            outerRadius={110}
            paddingAngle={4}
            dataKey="value"
            label={({ percent }) => {
                if (percent === 0) return "";
                return `${(percent * 100).toFixed(1)}%`;
              }}
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index]} />
            ))}
          </Pie>

          <Tooltip
            contentStyle={{
              backgroundColor: "#ffffff",
              border: "none",
              borderRadius: "8px",
              color: "#fff",
            }}
          />

          <Legend wrapperStyle={{ color: "#e2e8f0" }} />

          {/* Center total */}
          <text
            x="50%"
            y="50%"
            textAnchor="middle"
            dominantBaseline="middle"
            fill="#ffffff"
            style={{ fontSize: "22px", fontWeight: "600" }}
          >
            {total}
          </text>
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default MealPieChart;